import React, { useEffect } from 'react';

const VanillaEvents = ({ selector, events }) => {
  useEffect(() => {
    for (let ev of events) {
      document.querySelector(selector).addEventListener(ev.name, ev.func);
    }
    return () => {
      for (let ev of events) {
        document.querySelector(selector).removeEventListener(ev.name, ev.func);
      }
    };
  }, []);
  return <></>;
};

export default VanillaEvents;
